// extracted by mini-css-extract-plugin
export var avatarBone = "_8-4";
export var buttonBone = "_8-3";
export var continueBone = "_8-a";
export var frame = "_8-1";
export var logoBone = "_8-2";
export var pickerGrid = "_8-d";
export var pitchBone = "_8-9";
export var productBone = "_8-8";
export var sectionBone = "_8-7";
export var shell = "_8-0";
export var skeletonPulse = "_8-b";
export var subtitleBone = "_8-6";
export var titleBone = "_8-5";
export var viewport = "_8-c";